import z from 'zod'

export const GBP = 'GBP'
export const EUR = 'EUR'
export const USD = 'USD'
export const TRY = 'TRY'
export const ALL = 'ALL'
export const AMD = 'AMD'
export const AZN = 'AZN'
export const BYN = 'BYN'
export const BAM = 'BAM'
export const BGN = 'BGN'
export const CZK = 'CZK'
export const DKK = 'DKK'
export const GEL = 'GEL'
export const HUF = 'HUF'
export const ISK = 'ISK'
export const CHF = 'CHF'
export const MDL = 'MDL'
export const MKD = 'MKD'
export const NOK = 'NOK'
export const PLN = 'PLN'
export const RON = 'RON'
export const RUB = 'RUB'
export const RSD = 'RSD'
export const SEK = 'SEK'
export const UAH = 'UAH'

// https://en.wikipedia.org/wiki/ISO_4217
export const currencies = [
    GBP,
    EUR,
    USD,
    TRY,
    ALL,
    AMD,
    AZN,
    BYN,
    BAM,
    BGN,
    CZK,
    DKK,
    GEL,
    HUF,
    ISK,
    CHF,
    MDL,
    MKD,
    NOK,
    PLN,
    RON,
    RUB,
    RSD,
    SEK,
    UAH,
] as const satisfies { length: 25 }

export const currencyToCurrencyLabel = {
    GBP: '£ GBP',
    EUR: '€ EUR',
    USD: '$ USD',
    TRY: '₺ TRY',
    ALL: 'L ALL',
    AMD: '֏ AMD',
    AZN: '₼ AZN',
    BYN: 'Br BYN',
    BAM: 'KM BAM',
    BGN: 'лв BGN',
    CZK: 'Kč CZK',
    DKK: 'kr DKK',
    GEL: '₾ GEL',
    HUF: 'Ft HUF',
    ISK: 'kr ISK',
    CHF: 'Fr CHF',
    MDL: 'L MDL',
    MKD: 'ден MKD',
    NOK: 'kr NOK',
    PLN: 'zł PLN',
    RON: 'lei RON',
    RUB: '₽ RUB',
    RSD: 'Дин. RSD',
    SEK: 'kr SEK',
    UAH: '₴ UAH',
} as const satisfies Record<Currency, string>

export type CurrencyLabel = typeof currencyToCurrencyLabel[Currency]

export const CurrencySchema = z.enum(currencies)
export type Currency = z.infer<typeof CurrencySchema>

export const DEFAULT_CURRENCY = GBP
